/* tslint:disable */
export class MouseActionMode {
    active;
    meshes;
    info;
    intersected;
    selectedMesh;

    constructor() {
        this.active = false;
        this.meshes = [];
        this.info = [];
        this.intersected = null;
        this.selectedMesh = null;
    }
}
